import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const BlogPage = ({
  blogPage,
  setBlogPage,
  setSelectedPost,
  blogPosts,
  setCurrentPage,
  goToLeaderboard,
  mobileMenuOpen,
  setMobileMenuOpen
}) => {
  const sortedPosts = [...blogPosts].sort((a, b) => new Date(b.date) - new Date(a.date));

  const POSTS_PER_PAGE = 5;
  const totalPages = Math.ceil(sortedPosts.length / POSTS_PER_PAGE);
  const startIndex = (blogPage - 1) * POSTS_PER_PAGE;
  const endIndex = startIndex + POSTS_PER_PAGE;
  const currentPosts = sortedPosts.slice(startIndex, endIndex);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    });
  };

  const handlePostClick = (post) => {
    setSelectedPost(post);
    window.scrollTo(0, 0);
  };

  const handlePageChange = (page) => {
    setBlogPage(page);
    window.scrollTo(0, 0);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-500 via-purple-600 to-purple-800 overflow-x-hidden flex flex-col">
      <Header 
        setCurrentPage={setCurrentPage} 
        goToLeaderboard={goToLeaderboard}
        mobileMenuOpen={mobileMenuOpen}
        setMobileMenuOpen={setMobileMenuOpen}
      />
      <div className="flex-1 pt-20 p-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-8 sm:mb-12 text-white">
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4">The Prep Blog</h1>
          </div>

          <div className="space-y-6 mb-8">
            {currentPosts.map((post) => (
              <div
                key={post.id}
                onClick={() => handlePostClick(post)}
                className="bg-white rounded-xl shadow-lg p-6 cursor-pointer transition-all hover:shadow-2xl hover:scale-[1.02] hover:-translate-y-1"
              >
                <h2 className="text-2xl font-bold text-gray-900 mb-2">
                  {post.title}
                </h2>
                <time className="text-sm text-gray-600 mb-3 block">
                  {formatDate(post.date)}
                </time>
                <p className="text-gray-700 leading-relaxed">
                  {post.preview}
                </p>
                <div className="mt-4 text-purple-600 font-medium hover:text-purple-700">
                  Read more →
                </div>
              </div>
            ))}
          </div>

          {totalPages > 1 && (
            <div className="flex justify-center items-center gap-2 pb-8">
              <button
                onClick={() => handlePageChange(blogPage - 1)}
                disabled={blogPage === 1}
                className="p-2 rounded-lg bg-white text-purple-600 disabled:opacity-50 disabled:cursor-not-allowed hover:bg-purple-50 transition-colors"
              >
                <ChevronLeft size={20} />
              </button>
              
              {[...Array(totalPages)].map((_, index) => (
                <button
                  key={index + 1}
                  onClick={() => handlePageChange(index + 1)}
                  className={`px-4 py-2 rounded-lg font-medium transition-colors ${
                    blogPage === index + 1
                      ? 'bg-white text-purple-600'
                      : 'bg-white/20 text-white hover:bg-white/30'
                  }`}
                >
                  {index + 1}
                </button>
              ))}
              
              <button
                onClick={() => handlePageChange(blogPage + 1)}
                disabled={blogPage === totalPages}
                className="p-2 rounded-lg bg-white text-purple-600 disabled:opacity-50 disabled:cursor-not-allowed hover:bg-purple-50 transition-colors"
              >
                <ChevronRight size={20} />
              </button>
            </div>
          )}
        </div>
      </div>
      <div className="h-32"></div>
      <Footer setCurrentPage={setCurrentPage} goToLeaderboard={goToLeaderboard} />
    </div>
  );
};

export default BlogPage;